import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 15V19H13V15H14Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 6.58594V11H23V23H1V11H3V1H15.4141L21 6.58594ZM2.66699 13V15H4V19H2V21H4.7998C5.52624 21 5.99978 20.3905 6 19.7861V13H2.66699ZM7.75 13C7.17764 13 6.84389 13.3908 6.70898 13.6221C6.55997 13.8778 6.5 14.1653 6.5 14.4287V16.5713C6.5 16.8347 6.55997 17.1222 6.70898 17.3779C6.84389 17.6092 7.17764 18 7.75 18H8.5V19H6.5V21H9.25C9.82236 21 10.1561 20.6092 10.291 20.3779C10.44 20.1222 10.5 19.8347 10.5 19.5713V17.4287C10.5 17.1653 10.44 16.8778 10.291 16.6221C10.1561 16.3908 9.82236 16 9.25 16H8.5V15H10.5V13H7.75ZM12.375 13C11.4944 13 11 13.7693 11 14.4287V19.5713C11 20.2307 11.4944 21 12.375 21H14.625L14.7852 20.9912C15.5654 20.9045 16 20.1896 16 19.5713V14.4287C16 13.7693 15.5056 13 14.625 13H12.375ZM16.5 13V21H18.5V15H19.5V21H21.5V14.4287C21.5 13.8882 21.1225 13.0002 20.167 13H16.5ZM14.5 7.5H19L14.5 3V7.5Z"}}]};

const FileJsonFilled = Vue.extend<IconProps>({
  name: 'FileJsonFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'file-json-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FileJsonFilled;
